/* eslint-disable */
// import { widget } from '../../../public/charting_library';
import { widget } from '../../public/static/charting_library'
import Io from '../socket'
import Datafeeds from './datafeed'
import { formatTimeInBarToMs } from './utils'
// import { UDFCompatibleDatafeed } from '../../../public/datafeeds/udf/lib/udf-compatible-datafeed';

export default {
  queryData: {},
  tvWidget: null,
  dataFeed: null,
  dataCache: {}, // 缓存数据
  getBarTimer: null,
  resolution: null,
  realtimeCallback: {},
  isSubscribe: false,
  init: function (options, callback) {
    this.dataCache = {}
    this.isSubscribe = false
    this.queryData = options
    this.resolution = options.interval
    // this.dataFeed = new UDFCompatibleDatafeed(this)
    this.dataFeed = new Datafeeds(this)
    const widgetConfig_defalut = {
      debug: false,
      autosize: true,
      // toolbar_bg: true,
      // fullscreen: true,
      // symbol: options.symbol,
      symbol: options.name,
      interval: options.interval,
      container: options.container,
      datafeed: this.dataFeed,
      // library_path: '/charting_library/', // 包文件路径
      library_path: '/static/charting_library/', // 包文件路径
      // library_path: 'https://defibox1.s3.ap-northeast-1.amazonaws.com/charting_library/',
      timezone: 'Asia/Shanghai',
      // timezone: 'Etc/UTC',
      // 开启功能
      enabled_features: [
        // 'keep_left_toolbar_visible_on_small_screens',
        'side_toolbar_in_fullscreen_mode', // 全屏模式启用绘图工具
        'hide_left_toolbar_by_default', // 当用户第一次打开图表时隐藏左工具栏
        'left_toolbar', // 左侧菜单栏
        // 'header_indicators',
        // 'show_left_toolbar_by_default',
        'keep_left_toolbar_visible_on_small_screens', // 防止左侧工具栏在小屏幕上消失
        // 'hide_last_na_study_output', // 隐藏最后一次指标输出
        'move_logo_to_main_pane', // logo 图标位置 默认在左下
        // 'dont_show_boolean_study_arguments', // 隐藏指标参数
        'show_zoom_and_move_buttons_on_touch',
        // 'header_widget_dom_node',
        // 'main_series_scale_menu',
        // 'save_chart_properties_to_local_storage',
        'show_interval_dialog_on_key_press',
      ],
      // 关闭功能
      disabled_features: [
        // 'control_bar', // 底部的导航按钮(选择时间周期隐藏)
        'timeframes_toolbar', // 底部时间模块
        // 'main_series_scale_menu', // 隐藏图表右下角的设置按钮
        'symbol_search_hot_key', // 商品搜索热键
        'header_widget_dom_node', // 隐藏头部的时间选择
        'header_symbol_search', // 商品搜索
        'header_resolutions', // 分辨率时间范围切换
        // 'header_interval_dialog_button',
        // 'show_interval_dialog_on_key_press',
        // 'header_chart_type', // 隐藏图表类型切换
        // 'header_settings',
        // 'header_indicators', // 各种指标功能入口
        'header_compare', // 搜索商品
        'header_undo_redo', // 历史回溯
        // 'header_screenshot', // 下载图片
        'header_fullscreen_button',
        'volume_force_overlay', // 交易量单独一块
        // 'save_chart_properties_to_local_storage',
        // 'use_localstorage_for_settings',
      ],
      studies_overrides: {
        // 'paneProperties.legendProperties.showLegend': false,
        'volume.precision': 0,
        //柱状颜色修改
        // "volume.volume.color.0": "#F03869",
        // "volume.volume.color.1": "#09BB07"
      },
      // supported_resolutions:['5',"15","30","60",'240',"D","W","M"],
      custom_formatters: {
        priceFormatterFactory: (symbolInfo, minTick) => {
          return {
            format: (price, signPositive) => {
              if (price >= 1) {
                return Number(price).toFixed(4)
              } else {
                // console.log('price', price)
                price = Number(price.toString()).toFixed(18).toString()
                const priceVal = price.toString().split('.')[1] || '0.00'
                const indexOfs = priceVal.indexOf('0')
                let returnValue = ''
                let nums = 0
                let forConti = true
                for (let i = 0; i < priceVal.length; i++) {
                  const iNumber = Number(priceVal[i])
                  const iNumber1 = Number(priceVal[i + 1])
                  if (indexOfs === 0 && forConti) {
                    if (iNumber === 0 && iNumber1 === 0) {
                      nums++
                    } else {
                      forConti = false
                    }
                  }
                }
                if (nums > 3 && indexOfs === 0) {
                  returnValue = `0.${priceVal.slice(0, indexOfs + 1)}{${nums + 1}}${priceVal.slice(nums + 1, nums + 4)}`
                } else if ((nums === 2 || nums === 3) && indexOfs === 0) {
                  returnValue = Number(price).toFixed(8)
                } else {
                  returnValue = Number(price).toFixed(4)
                }
                return returnValue
              }
            },
          }
        },
      },
    }
    // console.log('widget', widget)
    // const container = this.$refs.chartContainer;
    // console.log('container', container)
    const widgetConfig = Object.assign(widgetConfig_defalut, options.wgconfig)
    const tvWidget = new widget(widgetConfig)
    this.tvWidget = tvWidget
    // console.log('this.tvWidget', this.tvWidget)
    this.resetData()
    callback()
  },

  resetData: function () {
    this.dataFrom = 0
    this.noMoreData = false
    this.isSubscribe = false
  },

  // getBars: function (symbol, resolution, from, to, callback, firstDataRequest) {
  getBars: function (symbol, resolution, periodParams, callback) {
    // console.log(store.state.app.klineConfig.interval, callback);
    let res = this.resolution //todo: bug, this.resolution != resolution
    // console.log('from:' + (new Date(from * 1000).toISOString().slice(0,19)));
    // console.log('to:' + (new Date(to * 1000).toISOString().slice(0,19)));
    // console.log('当前' + this.resolution, periodParams);

    if (this.noMoreData) {
      callback && callback({ s: 'no_data' })
      return
    }
    if (this.dataFrom > 0 && periodParams.to > this.dataFrom) {
      periodParams.to = this.dataFrom
    }
    if (periodParams.from >= periodParams.to) {
      callback && callback({ s: 'ok', bars: [] })
      return
    }
    // 请求数据
    const params = {
      resolution: res,
      // resolutions: interval,
      symbol: this.queryData.ticker,
      pairId: this.queryData.pairId,
      from: periodParams.from,
      to: periodParams.to,
    }
    // 请求并callback
    // Io.cfwsKline(client, params, KLineTime, true, (response, way) => {
    Io.cfwsKline(params, !this.isSubscribe, (response, way) => {
      this.isSubscribe = true
      if (way == 'all') {
        this.dataFrom = periodParams.from
        if (response.klines.length == 0) {
          this.noMoreData = true
          callback && callback({ s: 'no_data' })
        } else {
          const bars = []
          for (var element of response.klines) {
            const barTime = element.time / 1000
            if (barTime >= periodParams.from && barTime <= periodParams.to) {
              bars.push(element)
            }
          }
          bars.sort((l, r) => (l.time > r.time ? 1 : -1))
          // callback && callback({ s: 'ok', bars: bars })
          callback && callback({ s: 'ok', bars: bars.map((bar) => formatTimeInBarToMs(bar, resolution)) })
        }
      } else {
        var listenerGUID = symbol.toLowerCase() + '_#_' + this.resolution.toLowerCase()
        const _listenerGUID = listenerGUID.replace('+', '_')
        var realtimeCallback = this.realtimeCallback[_listenerGUID]
        if (typeof realtimeCallback == 'function') {
          realtimeCallback(response.klines[0])
        }
      }
    })
  },

  subscribeBars: function (symbolInfo, resolution, onRealtimeCallback, listenerGUID, onResetCacheNeededCallback) {
    const _listenerGUID = listenerGUID.replace('+', '_').toLowerCase()
    this.realtimeCallback[_listenerGUID] = onRealtimeCallback
    // console.log(this.realtimeCallback);
  },

  unsubscribeBars: function (listenerGUID) {
    const _listenerGUID = listenerGUID.replace('+', '_').toLowerCase()
    delete this.realtimeCallback[_listenerGUID]
  },

  // 设置配置信息
  getConfig: function () {
    // https://b.aitrade.ga/books/tradingview/book/UDF.html
    return {
      supports_search: true, //  请修改datafeed的searchSymbols函数
      supports_group_request: false, // 设置为true将无法进行单个商品解析
      supports_marks: true, // 请修改datafeed的getMarks函数
      supports_timescale_marks: true, // 请修改datafeed的getTimescaleMarks函数
      supports_time: true,
      supported_resolutions: ['5', '15', '30', '60', '240', '1D', '1W', '1M'],
    }
  },

  // 默认配置信息
  resolveTVSymbol: function (symbol) {
    // https://b.aitrade.ga/books/tradingview/book/Symbology.html
    // console.log('this.queryData', this.queryData)
    const pairIdList = ['0xed49d7719d7da326529d45ae5e952225ce8c00ea', '0xf9788697de52f56c998764d356e5cb86dc43a6ad']
    return {
      name: this.queryData.name,
      // 'exchange': 'Newdex',
      // 'data_status': 'streaming',
      data_status: 'streaming',
      'exchange-traded': '',
      'exchange-listed': '',
      timezone: 'Asia/Shanghai',
      minmov: 1,
      minmov2: 0,
      pointvalue: '', // 点值
      fractional: false,
      session: '24x7',
      has_intraday: true,
      has_no_volume: false,
      description: this.queryData.name,
      pricescale: this.queryData.pricescale,
      // pricescale:
      //   this.queryData.pairId == '0xed49d7719d7da326529d45ae5e952225ce8c00ea' ? 10 ** 13 : this.queryData.pricescale, // 保留小数位数 10000 4位
      ticker: this.queryData.ticker,
      has_weekly_and_monthly: true,
      // 'supported_resolutions': ['1', '5', '15', '30', '60', '1D', '1W', '1M'],
    }
  },

  getServerTime: function () {
    // 暂时由客户端生成时间
    return parseInt(Date.now() / 1000)
  },

  /*
   * 生成日期分辨率按钮
   * @params name 名称
   * @params active 是否选中
   * @params resolution [1, 5, 15, 30, 60, 1D, 1W]
   */
  createdDataBtn(name, active, resolution) {
    const _this = this
    const widget = _this.tvWidget
    // const buttonEvent = widget.createButton();
    const button = widget.createButton()
    // const button = buttonEvent[0];
    let className = 'button'
    // button.innerHTML = button.title = name;
    button.innerHTML = name
    if (active) className = 'button selected'
    button.className = className
    button.onclick = function () {
      _this.resolution = resolution
      _this.resetData()
      // const parent = button.parentNode.parentNode;
      const parent = button.parentNode.parentNode.parentNode
      const children = parent.getElementsByClassName('button')
      for (let i = 0; i < children.length; i++) {
        children[i].className = 'button'
      }
      button.className = 'button selected'
      widget.chart().setResolution(resolution, function onReadyCallback() {
        // console.log('resolution', resolution)
        // const klineConfig = _this.queryData.self.$store.state.app.klineConfig;
        // const klineConfig = localStorage.getItem('kline');
        // klineConfig.interval = resolution;
        // _this.queryData.self.$store.dispatch('setKlineConfig', klineConfig);
        // localStorage.setItem('kline', resolution)
      })
    }
  },

  /*
   * 全屏按钮
   */
  createdFillWinBtn() {
    const _this = this
    const widget = _this.tvWidget
    const buttonEvent = widget.createButton({ align: 'right' })
    // const button = buttonEvent[0];
    const button = buttonEvent
    window.fullscreenBtnEvent = buttonEvent
    // button.title = _this.queryData.self.$t('nav.fullScreen');
    button.title = '全屏'
    button.className = 'button fullscreen iconed apply-common-tooltip'
    button.id = 'fullscreenBtn'

    const img = document.createElement('img')
    img.src = 'https://s3.ap-northeast-1.amazonaws.com/1noahark.io/image/fullscreen1.png'
    img.alt = 'FullScreen'
    img.className = 'fullscreen'
    buttonEvent.append(img)
    button.onclick = function () {
      const tvid = document.getElementById('tv_chart_container')
      if (tvid.className === 'tv_chart_container_full') {
        tvid.className = ''
        // document.exitFullscreen()
        if (document.exitFullscreen) {
          document.exitFullscreen() // 标准退出全屏方法
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen() // iOS Safari
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen() // Firefox
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen() // IE11
        }
        button.innerHTML = ''
        button.title = '全屏'
        buttonEvent.append(img)
        return
      }
      tvid.className = 'tv_chart_container_full'
      // console.log('tvid', tvid)

      // tvid.requestFullscreen()

      if (tvid.requestFullscreen) {
        tvid.requestFullscreen() // 其他浏览器
      } else if (tvid.webkitRequestFullscreen) {
        tvid.webkitRequestFullscreen() // Safari 和 iOS Safari
      } else if (tvid.webkitEnterFullscreen) {
        tvid.webkitEnterFullscreen() // iOS Safari
      } else if (tvid.msRequestFullscreen) {
        tvid.msRequestFullscreen() // IE11
      }

      button.innerHTML = ''
      button.title = '离开全屏'
      buttonEvent.append(img)
    }
  },

  /*
   * k 线按钮
   */
  createdKlineBtn() {
    const _this = this
    const widget = _this.tvWidget
    const buttonEvent = widget.createButton({ align: 'right' })
    const button = buttonEvent[0]
    button.className = 'button selected iconed apply-common-tooltip'
    button.id = 'kLineBtn'
    buttonEvent.append('<span class="klinebtn">' + _this.queryData.self.$t('tv.kline') + '<span/>')
  },
  /*
   * 深度按钮
   */
  createdDepthBtn(callback) {
    const _this = this
    const widget = _this.tvWidget
    const buttonEvent = widget.createButton({ align: 'right' })
    const button = buttonEvent[0]
    window.depthBtnEvent = buttonEvent
    button.className = 'button iconed apply-common-tooltip'
    button.id = 'depthBtn'
    buttonEvent.append('<span class="depthBtn">' + _this.queryData.self.$t('tv.pool') + '<span/>')
    button.onclick = function () {
      callback()
    }
  },

  /*
   * 语言更换
   */
  tvSetLanguage(lang) {
    const _this = this
    const widget = _this.tvWidget
    widget.setLanguage(lang)
  },
}
